/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon24Regular = forwardRef('KonturBonusSignIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 1.25a.75.75 0 0 0-1.5 0v3H7A1.75 1.75 0 0 0 5.25 6v12c0 .966.784 1.75 1.75 1.75h4v3a.75.75 0 0 0 1.5 0v-3h1.625a4.375 4.375 0 1 0 0-8.75H6.75V6A.25.25 0 0 1 7 5.75h9.192a.75.75 0 0 0 0-1.5H12.5v-3ZM6.75 18v-5.5h7.375a2.875 2.875 0 0 1 0 5.75H7a.25.25 0 0 1-.25-.25Z" })));
});
